var ActionNames, account, combineReducers, editGallery, galleries, library;

combineReducers = require('redux').combineReducers;

ActionNames = require('./ActionNames');

account = function(state, action) {
  if (state == null) {
    state = null;
  }
  switch (action.type) {
    case ActionNames.AccountLoaded:
      return action.account;
    default:
      return state;
  }
};

galleries = function(state, action) {
  var g, gallery, ref, withoutGallery;
  if (state == null) {
    state = [];
  }
  switch (action.type) {
    case ActionNames.AccountLoaded:
      return (ref = action.account.galleries) != null ? ref : [];
    case ActionNames.GalleryLoaded:
      gallery = action.gallery;
      withoutGallery = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = state.length; i < len; i++) {
          g = state[i];
          if (g.id !== gallery.id) {
            results.push(g);
          }
        }
        return results;
      })();
      return withoutGallery.concat(gallery);
    default:
      return state;
  }
};

library = function(state, action) {
  if (state == null) {
    state = {
      photos: []
    };
  }
  switch (action.type) {
    case ActionNames.LibraryLoaded:
      return action.library;
    default:
      return state;
  }
};

editGallery = function(state, action) {
  var id, p;
  if (state == null) {
    state = {
      id: 0,
      name: 'New gallery',
      photoIds: []
    };
  }
  switch (action.type) {
    case ActionNames.LibraryPhotoToggled:
      return {
        id: state.id,
        name: state.name,
        photoIds: state.photoIds.indexOf(action.photoId) !== -1 ? (function() {
          var i, len, ref, results;
          ref = state.photoIds;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            id = ref[i];
            if (id !== action.photoId) {
              results.push(id);
            }
          }
          return results;
        })() : state.photoIds.concat(action.photoId)
      };
    case ActionNames.GalleryDetailsUpdated:
      return {
        id: action.id,
        name: action.name,
        photoIds: state.photoIds
      };
    case ActionNames.EditGalleryLoaded:
      return {
        id: action.id,
        name: action.name,
        photoIds: (function() {
          var i, len, ref, results;
          ref = action.photos;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            p = ref[i];
            results.push(p.name.toString());
          }
          return results;
        })()
      };
    default:
      return state;
  }
};

module.exports = combineReducers({
  account: account,
  galleries: galleries,
  library: library,
  editGallery: editGallery
});

//# sourceMappingURL=data:application/json;base64,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
